export default "__VITE_ASSET__BUQT$iz8__"